import {
  LucideArrowLeft,
  LucideArrowRight,
  LucideBarChart3,
  LucideCalendarDays,
  LucideCheck,
  LucideChevronLeft,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleCheck,
  LucideCircleX,
  LucideClipboardCheck,
  LucideClock,
  LucideExternalLink,
  LucideEye,
  LucideEyeOff,
  LucideInbox,
  LucideLayoutDashboard,
  LucideLoaderCircle,
  LucideLogOut,
  LucideMail,
  LucideMenu,
  LucidePlus,
  LucideRefreshCw,
  LucideRotateCw,
  LucideSearch,
  LucideSend,
  LucideShuffle,
  LucideSmartphone,
  LucideStore,
  LucideTicket,
  LucideTrash2,
  LucideTrophy,
  LucideUndo2,
  LucideUsers,
  LucideX,
  LucideZoomIn,
  LucideZoomOut,
  provideLucideIcons,
} from '@lucide/angular';

export const lucideIconsProvider = provideLucideIcons(
  LucideArrowLeft,
  LucideArrowRight,
  LucideBarChart3,
  LucideCalendarDays,
  LucideCheck,
  LucideChevronLeft,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleCheck,
  LucideCircleX,
  LucideClipboardCheck,
  LucideClock,
  LucideExternalLink,
  LucideEye,
  LucideEyeOff,
  LucideInbox,
  LucideLayoutDashboard,
  LucideLoaderCircle,
  LucideLogOut,
  LucideMail,
  LucideMenu,
  LucidePlus,
  LucideRefreshCw,
  LucideRotateCw,
  LucideSearch,
  LucideSend,
  LucideShuffle,
  LucideSmartphone,
  LucideStore,
  LucideTicket,
  LucideTrash2,
  LucideTrophy,
  LucideUndo2,
  LucideUsers,
  LucideX,
  LucideZoomIn,
  LucideZoomOut,
);
